import { useEffect, useState } from 'react';
import { customerService } from '../services/customerService';
import { documentService } from '../services/documentService';
import { LinkCompany, LinkUser, LinkDocument } from '../components/PrioritizeDetailModal';

/**
 * Loads the external data sources used by the feature popup's linked-section
 * pickers: companies + customer users (Customers module) and documents
 * (Docs Writer). Scoped to the active project. Failures are swallowed so the
 * popup still opens with empty pickers.
 */
export function useFeatureLinkData(orgId?: string | null, projectId?: string | null) {
  const [companies, setCompanies] = useState<LinkCompany[]>([]);
  const [customerUsers, setCustomerUsers] = useState<LinkUser[]>([]);
  const [documents, setDocuments] = useState<LinkDocument[]>([]);

  useEffect(() => {
    if (!orgId) return;
    let cancelled = false;
    (async () => {
      try {
        const [comp, users, docs] = await Promise.all([
          customerService.getCompanies(projectId).catch(() => []),
          customerService.getCustomerUsers(projectId).catch(() => []),
          documentService.getDocuments(projectId).catch(() => []),
        ]);
        if (cancelled) return;
        setCompanies(comp.map(c => ({ id: c.id, name: c.name })));
        setCustomerUsers(users.map(u => ({ id: u.id, name: u.name, email: u.email })));
        setDocuments(docs.map(d => ({ id: d.id, title: d.title })));
      } catch {
        /* leave pickers empty */
      }
    })();
    return () => { cancelled = true; };
  }, [orgId, projectId]);

  return { companies, customerUsers, documents };
}
